import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import useUpdateEffect from '../../hooks/useUpdateEffect';
import { getCurrentStates } from '../../services/clientService';
import { apiParamsState, isAllWorkspacesSelect, pageState } from '../../storage/app';
import { currentStatesState, updateCurrentStatesState } from '../../storage/client';
import { loadingCurrentStatesState } from '../../storage/currentStates';
import { assetStates } from '../../storage/tracking';
import { TRACKING_PAGE } from './../../constants/app';
import { currentStateState, updatedCurrentStateState } from './../../storage/client';

function ClientProvider() {
  const apiParams = useRecoilValue(apiParamsState);
  const setCurrentStates = useSetRecoilState(currentStatesState);
  const updatedCurrentState = useRecoilValue(updatedCurrentStateState);
  const setCurrentState = useSetRecoilState(currentStateState(updatedCurrentState ? updatedCurrentState.ident : ''));
  const setLoadingCurrentState = useSetRecoilState(loadingCurrentStatesState);
  const page = useRecoilValue(pageState);
  const { assetId } = useParams();
  const setAssetStates = useSetRecoilState(assetStates(assetId ?? ''));
  const updateCurrentStates = useRecoilValue(updateCurrentStatesState);
  const isAllWorkspacesSelected = useRecoilValue(isAllWorkspacesSelect);

  useEffect(() => {
    const invalid = !apiParams?.clientId || !apiParams.subClientId;
    if (invalid) return;

    const loadCurrentState = async () => {
      setLoadingCurrentState(true);
      const { currentStates, error } = isAllWorkspacesSelected
        ? await getCurrentStates(apiParams.clientId)
        : await getCurrentStates(apiParams.clientId, apiParams.subClientId);
      if (!error && currentStates) {
        setCurrentStates(currentStates);
      } else {
        setCurrentStates(undefined);
      }
      setLoadingCurrentState(false);
    };
    loadCurrentState();
  }, [apiParams?.clientId, apiParams?.subClientId, updateCurrentStates, setCurrentStates, setLoadingCurrentState]);

  useUpdateEffect(() => {
    if (updatedCurrentState) {
      setCurrentState(updatedCurrentState);
      if (page === TRACKING_PAGE.id && assetId === updatedCurrentState.asset._id) {
        setAssetStates((prev) => {
          if (prev) {
            return [...prev, updatedCurrentState];
          }
          return [updatedCurrentState];
        });
      }
    }
  }, [updatedCurrentState]);

  return null;
}

export default ClientProvider;
